<template>
  <div>
    <div class="flex flex-col">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div class="align-middle inline-block min-w-full overflow-hidden sm rounded-lg rounded-tl-none border border-gray-200">
          <table class="min-w-full">
            <thead>
            <tr>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
              </th>
              <th class="px-2 w-full py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Item / Details
              </th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                Qty
              </th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Qty Approved</th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Warehouse</th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Delivered</th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Price</th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Discount</th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">Amount</th>
              <th class="px-2 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"></th>
            </tr>
            </thead>

            <tbody class="bg-white">
            <tr v-for="(item, index) in value" :key="index" class="p-0">
              <td class="p-0 whitespace-nowrap border-b border-gray-200 text-sm font-medium text-gray-900">
                <input
                  type="checkbox"
                  v-model="checkedItems[item.id]" :id="'item-'+item.id"
                  class="mx-2 form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                  :disabled="!can_update_order_items && orderIsCompleted === false || isItemLocked(item)"
                />
              </td>
              <td class="p-0 border-b border-gray-200 font-medium text-gray-900 flex items-center">
                <label :for="'item-'+item.id" class="py-2 w-full leading-3" :class="{'text-red-500' : duplicateItems[item.item_code] }">
                  <span class="text-xs">{{ item.description }}</span>
                  <span v-if="item.free_item" class="text-xs text-green-500 uppercase text-md">Free</span>
                  <div class="text-xs text-gray-400">
                    {{ item.item_code }}
                  </div>
                  <div v-if="item.special_offer" class="text-xs italic text-gray-300">
                    <span class="font-bold">OFFER | </span> {{ item.special_offer.title }}
                  </div>
                </label>

              </td>
              <td class="p-0  whitespace-nowrap border-b border-gray-200 text-sm text-gray-500">
                <span class="mr-1">{{ item.quantity }}</span><span class="text-xs" :class="{'text-red-400': item.base_unit !== item.unit}">{{ item.unit }}</span>
              </td>
              <td class="p-0 whitespace-nowrap border-b border-gray-200 text-sm text-gray-500">
                <div class="flex items-center">
                  <input type="number" class="form-number-text w-16 p-2 rounded bg-gray-100 text-center mr-2 border-0" :disabled="!can_update_order_items || isLocked || isItemLocked(item)" :min="0" v-model.number="item.quantity_approved" @change="evt => updateItemPrice(item, evt)"/>
                  <div>
                    <available-qty-badge v-if="available_qty.loaded" :item="available_qty.items[item.item_code]" :unit="item.unit" :qty="item.quantity_approved" />
                  </div>
                </div>
              </td>
              <td class="p-0 whitespace-nowrap border-b border-gray-200 text-sm text-gray-500">
                <div class="w-full flex-col items-stretch px-2 flex">
                  <select class="border-none" :errors="$page.props.errors[`items.${index}.warehouse_id`]" v-if="canChangeItemLocation(item)" v-model="item.warehouse_id" @change="fetchAvailableQty(item)">
                    <option v-for="(warehouse, windx) in getWarehouseListFor(item.item_code)" :value="warehouse.id" :key="windx">{{ warehouse.name }}</option>
                  </select>
                  <span v-else>
                    {{ getWarehouseListFor(item.item_code).find((wh) => wh.id === item.warehouse_id).name }}
                  </span>
                </div>
              </td>
              <td class="px-2whitespace-nowrap border-b border-gray-200 text-sm text-gray-500 text-center">
                <span v-if="item.quantity_delivered" class="rounded p-2 border">{{ item.quantity_delivered }}</span>
                <span v-else class="rounded p-2 border">0</span>
              </td>
              <td class="px-2whitespace-nowrap border-b border-gray-200 text-sm text-gray-500 text-right pr-4">
                <span v-if="item.unit_price">{{ item.unit_price.toLocaleString() }}</span>
                <span v-else>
                  <span v-if="item.free_item">0</span>
                  <span v-else>N/A</span>
                </span>
              </td>
              <td class="px-2whitespace-nowrap border-b border-gray-200 text-sm text-gray-500 text-right pr-4">
                {{ item.discount_applied.toLocaleString() }}
              </td>
              <td class="px-2whitespace-nowrap border-b border-gray-200 text-sm text-gray-500 text-right">
                <div v-if="!item.discount_total_price">{{ item.price_total.toLocaleString() }}</div>
                <div v-else>
                  <div class="text-sm">{{ item.discount_total_price.toLocaleString() }}</div>
                  <div class="text-xs line-through text-gray-400">{{ item.price_total.toLocaleString() }}</div>
                </div>
              </td>
              <td class="py-0 px-1 whitespace-nowrap border-b border-gray-200 text-sm text-gray-500">
                <button v-if="item.completed_at" title="Delivered" class="block w-4 h-4 text-green-600" @click="$refs.orderfulfillmenet.showDetailsByOtpId(item.handovers[0].order_otp_id || null)"><Icon name="tick"></Icon></button>
                <button v-else-if="item.delivery_items.length && item.delivery_items.filter(itm => itm.quantity_handover).length" title="In Progress" class="block w-4 h-4 text-yellow-500"><icon name="truck"></icon></button>
                <button v-else-if="item.handovers.length" title="In Progress" class="block w-4 h-4 text-orange-500"><icon name="tick"></icon></button>
              </td>
            </tr>
            <tr class="bg-gray-100">
              <th colspan="7" class="text-right">Total</th>
              <th class="py-3 px-2 text-right" colspan="3"><span class="text-sm font-normal">MVR</span> {{ total_price.toLocaleString() }}</th>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="mt-4 flex flex-col md:flex-row justify-between md:items-end gap-4">
      <dl class="text-sm leading-5 space-y-1 flex-shrink-0">
        <dt class="font-medium">Last Updated:</dt>
        <dd>{{ lastUpdated | localDateTime }}</dd>
      </dl>
      <div class="flex-1 flex items-center justify-end gap-x-2">
        <div>
          <button class="btn-red" v-if="['approved', 'quoted', 'invoiced'].indexOf(orderStatus) != -1"  @click="revertStatusToOpen" >Revert Status</button>
        </div>
        <div v-if="canAdmin('reopen-cancelled-order') && orderStatus === 'cancelled'">
          <button class="flex items-center bg-red-200 text-red-400 rounded" @click="revertStatusToOpen" >ReOpen Order</button>
        </div>
        <div v-if="canAdmin('remove-items-from-an-order') && !orderIsCompleted">
          <RemoveOrderItemModal
            v-slot="{open}"
            :items="value"
            :checked-items="checkedItems"
            :remove-order-item-url="route('customer.orders.remove-items', orderId)"
          >
              <button
                class="btn-primary"
                v-if="['open', 'approved', 'quoted', 'payment_process','review'].indexOf(orderStatus) != -1"
                :disabled="disableRemoveButton"
                @click="open"
              >
                Remove Selected
              </button>
          </RemoveOrderItemModal>
        </div>
        <div v-if="['open', 'approved', 'quoted'].indexOf(orderStatus) != -1 && canAdmin('update-items-in-order')">
          <UpdateOrderItemsModal
            v-slot="{open}"
            :items="value"
            :selected-items="checkedItems"
            :update-order-items-url="route('ajax.customer.orders.update-items-in-order', orderId)"
            :order-id="orderId"
            @updated="onItemsUpdated"
          >
            <button class="btn-primary" :disabled="disableRemoveButton" @click="open">Update Items Selected</button>
          </UpdateOrderItemsModal>
        </div>
        <div v-if="canAdmin('add-items-to-order')">
          <AddItemToOrder
            v-slot="{open}"
            :warehouseList="warehouseList"
            :order-id="orderId"
            @itemAdded="onItemAdded"
          >
            <button :disabled="!can_update_order_items" class="btn-primary" v-if="['open', 'approved', 'quoted', 'payment_process', 'review'].indexOf(orderStatus) != -1" @click="open">Add Item</button>
          </AddItemToOrder>
        </div>
        <div v-if="!approvedAt && canAdmin('approve-orders')">
          <LoadingButton
            :disabled="isLocked"
            :class="{'bg-gray-300 hover:bg-gray-200': isLocked}"
            class="btn bg-green-400 rounded text-green-800 btn-primary"
            :loading="processing"
            @click="$emit('approveOrder')"
          >
            Approve
          </LoadingButton>
        </div>
        <div v-if="canAdmin('update-orders') || canAdmin('update-order-item-location')">
          <LoadingButton
            class="btn-primary"
            :loading="processing"
            :disabled="processing"
            @click="$emit('updateOrder')"
          >
            Update order
          </LoadingButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AvailableQtyBadge from "@/Shared/AvailableQtyBadge.vue";
import RemoveOrderItemModal from "./RemoveOrderItemModal.vue";
import UpdateOrderItemsModal from "./UpdateOrderItemsModal.vue";
import LoadingButton from "../../../../Shared/LoadingButton.vue";
import AddItemToOrder from "./AddItemToOrder.vue";
import Icon from "../../../../Shared/Icon.vue";

export default {
  name: 'OrderItems',
  components: {Icon, AddItemToOrder, LoadingButton, UpdateOrderItemsModal, RemoveOrderItemModal, AvailableQtyBadge},

  props: {
    value: Array,
    duplicateItems: [Object,Array],
    can_update_order_items: Boolean,
    isLocked: Boolean,
    updateItemPrice: Function,
    getWarehouseListFor: Function,
    canChangeItemLocation: Function,
    total_price: Number,
    lastUpdated: String,
    orderId: Number,
    orderStatus: String,
    orderIsCompleted: Boolean,
    processing: Boolean,
    warehouseList: Array,
    approvedAt: null,
  },

  data() {
    return {
      checkedItems: {},
      available_qty: {
        loaded: false,
        items: {}
      },
    }
  },

  computed: {
    isItemLocked() {
      return function (item) {
        return item.completed_at !== null || item.delivery_items.length > 0;
      }
    },
    disableRemoveButton() {
      if (Object.keys(this.checkedItems).length) {
        let values = Object.values(this.checkedItems)
        return values.filter(itm => itm === true).length === 0;
      }
      return true
    }
  },

  methods: {
    fetchAvailableQty(item) {
      this.available_qty.loaded = false;
      this.$http.get(this.route('ajax.order_item.quantity',{
        order_id:item.order_id, item_code:item.item_code, unit: item.unit, warehouse_id: item.warehouse_id
      })).then((response) => {

        let existing = this.available_qty.items[response.data.item_code] || {}
        this.available_qty.items = {
          ...this.available_qty.items,
          [response.data.item_code] : {
            ...existing,
            [response.data.unit] : response.data,
          }
        };
        this.available_qty.loaded = true;
      })
    },

    revertStatusToOpen() {
      this.orderUpdating = true;
      this.$inertia.post(this.route('customer.orders.revert_status', this.orderId), {
        orderId: this.orderId
      },{
        onSuccess : () => this.orderUpdating = false
      })
    },

    onItemsUpdated() {
      alert('dd')
    },

    onItemAdded() {
      this.$inertia.reload({
        only: ['order', 'order_total_price', 'warehouses', 'locations', 'warehouse0list', 'duplicateItems'],
      })
    }
  },
}
</script>
